import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '@ionic/storage-angular';
import { CommonProvider } from './../../commonServices/common';
import { Component, Input, OnInit } from '@angular/core';
// import { Keyboard } from '@ionic-native/keyboard/ngx';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { Router } from '@angular/router';
import {
  LoadingController,
  ModalController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { Apiurl } from '../../commonServices/route';
import { ClubService } from '../../../../providers/club-service/club-service';
import * as globals from '../../../../globals';
import { ClubInfo, ClubList, CourseInfo, createClubList } from 'src/data/club-course';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { getDistanceInKM } from '../../../../globals';
import { NewGameInfo } from '../../../../data/game-round';
import { PerformanceClubListPage1 } from '../club-list1/club-list1.page';
import { SetupPlayingCoursesPage } from '../../normalgame/select-courses/setup-player-courses/setup-player-courses.page';
import { PlayerHomeDataService } from '../../../../redux/player-home/player-home-data-service';
import { map } from 'rxjs/operators';
import { PerformanceCourseListPage } from '../course-list/course-list.page';
import { Keyboard } from '@ionic-native/keyboard/ngx';
@Component({
  selector: 'app-recent-club',
  templateUrl: './recent-club.page.html',
  styleUrls: ['./recent-club.page.scss'],
})
export class RecentClubPage implements OnInit {
  public refresher: any;
  public infinite: any;

  public recentClubs: Array<ClubInfo>;
  public nearByClubs: Array<ClubInfo>;

  public gameInfo: NewGameInfo;
  public clubList: ClubList;

  public openedModal: boolean = false;
  public searchQuery: string = '';
  public courseId: number;
  public courseName: string;
  public prevClubName: string;
  public prevCourseInfo: CourseInfo;

  public courseType: string;
  public clubInfo: ClubInfo;
  public prevClubInfo: ClubInfo;

  public courseInfo: CourseInfo;
  searchMode: boolean = false;

  searchDistance: number = 100;
  multiSelect: boolean = false;
  multiClub: Array<ClubInfo> = new Array<ClubInfo>();
  @Input() recentClubType: string = 'All';

  constructor(
    // private keyboard: Keyboard,
    private clubService: ClubService,
    private router: Router,
    private playerHomeService: PlayerHomeDataService,
    private CommonProvider: CommonProvider,
    private storage: Storage,
    public http: HttpClient,
    private loadingCtl: LoadingController,
    private navParams: NavParams,
    private geo: GeolocationService,
    private keyboard: Keyboard,

    private toastCtl: ToastController,
    private platform: Platform,
    private modalCtl: ModalController
  ) {
    this.gameInfo = {
      courses: [],
      players: [],
      availablePlayers: [],
    };

    this.clubList = createClubList();
    this.openedModal = navParams.get('openedModal');

    this.prevCourseInfo = navParams.get('courseInfo');
    this.prevClubName = navParams.get('clubName');

    this.courseId = navParams.get('courseId');
    this.courseName = navParams.get('courseName');

    this.courseType = navParams.get('courseType');

    this.clubInfo = navParams.get('clubInfo');
    this.prevClubInfo = navParams.get('clubInfo');

    this.courseInfo = navParams.get('courseInfo');
    this.prevCourseInfo = navParams.get('courseInfo');

    this.multiSelect = navParams.get('multiSelect');
  }

  async ngOnInit() {
    // await this.storage.create();
    // this._refreshValues();

    this.playerHomeService
      .playerHomeInfo()
      .pipe(map(data => data.player))
      .subscribe(player => {
        this.gameInfo.players.push(player);
        this._refreshValues();
      });
    // this.GetnearbyClubs();
  }

  gotopage(pagename) {
    this.router.navigate([pagename]);
  }

  onSearchInput(event) {
    this._clearItems();
    this._refreshClubs(null, null);
  }

  private _refreshClubs(refresher, infinite) {
    // let busy = this.loadCtl.create({
    //     content: "Please wait..."
    // });
    // busy.present().then(()=>{
    this.clubService.searchClubs(this.searchQuery, true, this.clubList.currentPage + 1).subscribe(
      (clubList: ClubList) => {
        // busy.dismiss().then(()=>{
        this.clubList.currentPage = clubList.currentPage;
        this.clubList.totalPages = clubList.totalInPage;
        this.clubList.totalItems = clubList.totalItems;
        this.clubList.clubs.push(...clubList.clubs);

        // });
      },
      error => {
        // busy.dismiss().then(()=>{
        let msg = MessageDisplayUtil.getErrorMessage(error, 'Error getting club list');
        MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
        // })
      },
      () => {
        //Handle the refresher or infinite
        if (refresher && refresher.complete) refresher.complete();
        if (infinite) {
          if (infinite.complete) infinite.complete();
          if (this.isMore()) {
            infinite.enable(true);
          } else infinite.enable(false);
        }
        if (this.platform.is('ios') || this.platform.is('capacitor')) this.keyboard.hide();
      }
    );
    // });
  }

  private _refreshValues() {
    this.clubService.getNearbyClubs(this.searchDistance).subscribe(
      (clubs: Array<ClubInfo>) => {
        this.nearByClubs = clubs;
      },
      error => {},
      () => {
        if (this.refresher) {
          this.refresher.complete();
          this.refresher = null;
        }
      }
    );
    this.clubService.getRecentClubs(5, this.recentClubType).subscribe(
      (clubs: Array<ClubInfo>) => {
        this.recentClubs = clubs;
      },
      error => {},
      () => {
        if (this.refresher) {
          this.refresher.complete();
          this.refresher = null;
        }

        //                 if(this.recentClubs.length===0) {
        //                   this.searchClubs();
        //                 }
      }
    );
  }

  close() {
    this.modalCtl.dismiss({ courseInfo: this.prevCourseInfo, clubInfo: this.prevClubInfo });
  }

  async searchClubs() {
    let clubModal = await this.modalCtl.create({
      component: PerformanceClubListPage1,
      componentProps: {
        openedModal: true,
        clubInfo: this.clubInfo,
        courseInfo: this.courseInfo,
      },
    });
    clubModal.onDidDismiss().then((data: any) => {
      //Check whether the club info is passed

      if (data.data.flag == true) {
        this.modalCtl.dismiss({ clubInfo: data.data.clubInfo }, null, 'RecentClubPage');
        // this.modalCtl.dismiss({ courseInfo: this.prevCourseInfo, clubInfo: this.prevClubInfo });
        // this.modalCtl.dismiss({ clubInfo: data.data.clubInfo });
      }
      // if (data.data.clubInfo) {
      //   this.clubInfo = data.data.clubInfo;
      //   this.clubSelected(1, data.data.clubInfo);
      // }
    });
    clubModal.present();
  }

  private _clearItems() {
    this.clubList = createClubList();
    if (this.searchQuery == '') {
      this.searchMode = false;
      return false;
    } else this.searchMode = true;
  }

  async clubSelected(event, item: ClubInfo) {
    if (this.multiSelect) {
      this.onMultiClubSelected(item);
      return false;
    }
    if (0) {
      //this.openedModal

      this.modalCtl.dismiss({ clubInfo: item });
    } else {
      // this.events.publish("ClubSelected:Name", item.clubName);
      /*this.nav.push(PerformanceCourseListPage, {
       courseId: this.courseId,
       courseName: this.courseName,
       club: item
       });*/

      if (this.courseType == 'course') {
        let clubCourse = await this.modalCtl.create({
          component: PerformanceCourseListPage,
          componentProps: {
            courseId: this.courseId,
            courseName: this.courseName,
            clubInfo: item,
            courseInfo: this.courseInfo,
          },
        });

        clubCourse.onDidDismiss().then((data: any) => {
          // courseInfo: CourseInfo, courseId: number, courseName: string
          //this.courseInfo = courseInfo

          // this.clubInfo = data.courseInfo;

          if (!data) {
            this.modalCtl.dismiss({
              apply: false,
              courseInfo: this.prevCourseInfo,
              clubInfo: this.prevClubInfo,
            });
            return false;
          } else if (data) {
            if (!data.data.courseInfo) {
              this.courseName = 'Please choose a course';

              this.modalCtl.dismiss({
                apply: data.data.apply,
                courseInfo: this.prevCourseInfo,
                clubInfo: this.prevClubInfo,
              });
              return false;
            } else if (data.data.courseInfo) {
              this.clubInfo = data.data.courseInfo;

              if (this.openedModal) {
                this.modalCtl.dismiss(
                  {
                    apply: data.data.apply,
                    courseInfo: data.data.courseInfo,
                    clubInfo: item,
                  },
                  null,
                  'RecentClubPage'
                );
              }
            }
          }

          //this.searchCriteria = this.perfService.getSearch();
          //this.perfService.setPerformanceFilter(this.searchCriteria.performanceHolesPlayed, this.courseInfo.courseId);

          //if(apply) this.refreshAnalysisHole();
        });
        clubCourse.present();
      } else if (this.courseType == 'club') {
        this.clubInfo = item;
        this.modalCtl.dismiss({ clubInfo: item });
      }
    }
  }

  onMultiClubSelected(item: ClubInfo) {
    // this.multiClub.push(item);
    let _hasClub;

    if (this.multiClub && this.multiClub.length > 0) {
      _hasClub = this.multiClub.filter(c => {
        if (c.clubId === item.clubId) return true;
        else return false;
      });
      if (_hasClub && _hasClub.length > 0) return false;
      else this.multiClub.push(item);
    } else {
      this.multiClub.push(item);
    }
  }
  onRefreshClick(refresher) {
    this.refresher = refresher;
    this._refreshValues();
  }

  clubDistance(club: ClubInfo) {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
      return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + ' KM';
    return '';
  }

  getMultiClubText() {
    let _clubList = '';
    this.multiClub.forEach((c: ClubInfo, idx: number) => {
      // if(idx > 0)
      _clubList += c.clubName + ', ';
    });
    return _clubList; //.slice(0,-1);// .substring(0,_playersList.length-1);
  }
  isMore(): boolean {
    return (
      this.clubList &&
      this.clubList.totalPages > 0 &&
      this.clubList.currentPage < this.clubList.totalPages
    );
  }

  filterClubSelected(event, data: ClubInfo) {
    this.clubSelected(null, data);
  }

  clearMultiClub() {
    this.multiClub.pop();
  }

  selectMultiClubs() {
    this.modalCtl.dismiss({
      confirm: true,
      multiClub: this.multiClub,
    });
  }

  doInfinite(event) {
    event?.target?.complete();
  }
}
